export const Config = () => ({
  myUpdates: process.env.REACT_APP_UPDATES_CONFIG === 'FALSE',
});

export const disableMyUpdates = () => {
  return Config().myUpdates;
};

export const shorterDateFormat = 'd.M.yy';
export const shortDateFormat = 'd.M.yyyy';
export const dotDateFormat = 'd.M.yyyy';
export const slashDateFormat = 'dd/MM/yyyy';
export const dotDateFormatMM = 'dd.MM.yyyy';

export const autocompleteShowResultInputLimit = 1;

export const mokedNumber = '*8150';

export const MAX_FILE_SIZE_IN_MB = 20;

export const EquipmentPageSize = 10;

export const DEFAULT_AUTOCOMPLETE_RESULT_LIMIT = 10;

export const defaultMinDate = new Date('1/1/1900');

export const burgerMenuItemsPersonalDetailsAndUpdatesSlicer = 2;
